export const SUB_CATEGORY_REPAIR = ["แจ้งซ่อมหัว", "แจ้งซ่อมหางรถ", "แจ้งซ่อมหัวและหางรถ"];